/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rap_Nav_GuideInputs */

const en_rap_nav_guide = /** @type {(inputs: Rap_Nav_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide`)
};

/**
* | output |
* | --- |
* | "Guide" |
*
* @param {Rap_Nav_GuideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const rap_nav_guide = /** @type {((inputs?: Rap_Nav_GuideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rap_Nav_GuideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_rap_nav_guide(inputs)
});
export { rap_nav_guide as "rap.nav.guide" }